/**
 * Job Priorities API
 *
 * API client functions for fetching distinct priority options from active jobs.
 *
 * Endpoint : GET /jobs/job-priorities
 * Method   : GET
 * Backend  : apps/backend/src/domains/works-lite/jobs/job-priorities/routes.ts
 */

import { apiClient } from '@/lib/api';
import type { JobPriority } from '@skewb-works/contracts';

// Re-export the shared type so consumers don't need to import from contracts directly
export type { JobPriority };

/**
 * Fetch distinct priority values for the work orders priority filter dropdown.
 */
export async function getJobPriorities(): Promise<JobPriority[]> {
  return apiClient.get<JobPriority[]>('/jobs/job-priorities');
}
